<template>
  <div class="register">
    <v-stepper class="stepper" v-model="selectedStep" dark>
      <v-stepper-header>
        <v-stepper-step color="green" step="1">Persönliches</v-stepper-step>
        <v-divider></v-divider>

        <v-stepper-step color="green" step="2">Profilbild</v-stepper-step>
        <v-divider></v-divider>

        <v-stepper-step color="green" step="3">Scoutdaten</v-stepper-step>
        <v-divider></v-divider>

        <v-stepper-step color="green" step="4" complete>Match-Abos</v-stepper-step>
      </v-stepper-header>

      <v-stepper-items class="items">
        <v-stepper-content class="content" step="1">
          <h1>
            Damit wir <span class="green-text">dich</span> ideal bei interessanten
            Talenten präsentieren können, benötigen wir noch einige wichtige Infos von
            dir.
          </h1>

          <hr class="green-line" />

          <label>
            Geburtsdatum
            <span>*</span>
          </label>
          <v-menu
            ref="menu"
            v-model="menu"
            locale="de"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            full-width
            color="green"
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                color="green"
                v-model="user_data.birthday"
                prepend-icon="event"
                readonly
                solo
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              color="green"
              ref="picker"
              locale="de"
              v-model="user_data.birthday"
              :max="new Date().toISOString().substr(0, 10)"
              min="1900-01-01"
            ></v-date-picker>
          </v-menu>

          <label>
            Geschlecht
            <span>*</span>
          </label>
          <v-select
            color="green"
            :items="sex"
            v-model="user_data.gender"
            solo
          ></v-select>

          <label> Nationalität <span>*</span> </label>
          <v-select
            v-model="user_data.nationality"
            :items="$store.state.nationalities"
            item-text="item_text"
            item-value="id"
            color="green"
            solo
          >
            <template v-slot:item="slotProps">
              <i
                :class="['mr-2', 'em', `em-flag-${slotProps.item.id.toLowerCase()}`]"
              ></i>
              {{ slotProps.item.item_text }}
            </template>
          </v-select>

          <label>Sprachen <span>*</span></label>
          <v-select
            solo
            v-model="user_data.languages"
            color="green"
            :items="$store.state.languages"
            chips
            multiple
          ></v-select>

          <label>Aktueller Wohnsitz <span>*</span></label>

          <!-- <label>Postleitzahl <span>*</span></label> -->
          <v-text-field
            color="green"
            v-model="user_data.zip_code"
            mask="#####"
            placeholder="Postleitzahl"
            solo
          ></v-text-field>

          <!-- <label>Ort, Bundesland</label> -->
          <v-text-field
            color="green"
            v-model="user_data.ort_bundesland"
            placeholder="Ort, Bundesland"
            solo
          ></v-text-field>

          <!-- <label>
            Wohnsitz (Land)
            <span>*</span>
          </label> -->
          <v-autocomplete
            color="green"
            :items="$store.state.countries.filter((c) => c === 'Deutschland')"
            v-model="user_data.place_of_living"
            placeholder="Land"
            disabled
            solo
          ></v-autocomplete>

          <v-btn
            color="green white--text"
            :disabled="
              !user_data.birthday ||
              !user_data.gender ||
              !(user_data.languages && user_data.languages.length) ||
              !user_data.nationality ||
              !user_data.place_of_living ||
              !user_data.zip_code ||
              !user_data.ort_bundesland
            "
            @click="next"
            >Weiter</v-btn
          >
        </v-stepper-content>

        <v-stepper-content class="content" step="2">
          <div v-if="user_data.big_thumbnail" class="upload-change-wrapper">
            <img
              class="register-avatar register-avatar__big"
              :src="user_data.big_thumbnail"
              alt=""
            />
            <label class="upload-label" for="upload-photo"
              ><b class="green-text">Profilbild</b> hochladen</label
            >
            <input
              class="upload-file-input"
              @change="croppie"
              type="file"
              accept="image/*"
              name="photo"
              id="upload-photo"
            />
          </div>
          <div v-else class="upload-wrapper">
            <label class="upload-label" for="upload-photo"
              ><b class="green-text">Profilbild</b> hochladen</label
            >
            <input
              class="upload-file-input"
              @change="croppie"
              type="file"
              accept="image/*"
              name="photo"
              id="upload-photo"
            />
          </div>

          <br />
          <v-btn color="white green--text" @click="back" text>Zurück</v-btn>
          <v-btn color="green white--text" @click="next" :disabled="!imageSrc"
            >Weiter</v-btn
          >
        </v-stepper-content>

        <v-stepper-content class="content" step="3">
          <label>
            Scoutgebiet
            <span>*</span>
          </label>
          <v-select
            color="green"
            :items="$store.state.scoutarea"
            v-model="user_data.scoutarea"
            solo
            multiple
          ></v-select>

          <label>
            Scoutbereich
            <span>*</span>
          </label>
          <v-select
            color="green"
            :items="$store.state.scout_segment"
            v-model="user_data.bundesland"
            solo
            multiple
          ></v-select>

          <div>
            <label>
              Tätig seit
              <span>*</span>
            </label>
            <v-menu
              ref="since_menu"
              v-model="since_menu"
              locale="de"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  color="green"
                  v-model="formatSinceDate"
                  prepend-icon="event"
                  readonly
                  v-on="on"
                  solo
                ></v-text-field>
              </template>
              <v-date-picker
                color="green"
                locale="de"
                v-model="user_data.working_since"
                type="month"
                no-title
                scrollable
              >
                <v-spacer></v-spacer>
                <v-btn
                  text
                  min="1900-01-01"
                  :max="new Date().toISOString().substr(0, 10)"
                  color="green white--text"
                  @click="$refs.since_menu.save(user_data.working_since)"
                  >OK</v-btn
                >
              </v-date-picker>
            </v-menu>
          </div>

          <label>
            Tätig für
            <span>*</span>
          </label>
          <v-text-field
            placeholder="Vereins-, Unternehmens- oder Agenturname "
            color="green"
            v-model="user_data.working_for"
            solo
          ></v-text-field>

          <v-btn color="white green--text" @click="back" text>Zurück</v-btn>
          <v-btn
            color="green white--text"
            @click="next"
            :disabled="
              !user_data.scoutarea ||
              !user_data.bundesland ||
              !user_data.working_for ||
              !user_data.working_since
            "
            >Weiter</v-btn
          >
        </v-stepper-content>

        <v-stepper-content class="content" step="4">
          <h1>
            Mit den <span class="green-text">Match-Abos</span><span>*</span> kannst du
            während der gesamten Laufzeit unbegrenzt Spieler und Trainer matchen.
            Zusätzlich kannst du dich mit jedem Verein connecten, um ihm dein
            Talentportfolio vorzustellen.
          </h1>

          <p>
            Die nachfolgenden Preise beziehen sich auf die jeweilige Laufzeit und sind
            Liga unabhängig.
          </p>
          <table class="table-price">
            <tr>
              <td class="text-left">3 Monate</td>
              <td class="text-right">399,00 €</td>
            </tr>
            <tr>
              <td class="text-left">6 Monate</td>
              <td class="text-right">599,00 €</td>
            </tr>
            <tr>
              <td class="text-left">12 Monate</td>
              <td class="text-right">899,00 €</td>
            </tr>
            <tr>
              <th colspan="2" class="text-right">Preise sind inkl. ges. MwSt.</th>
            </tr>
          </table>

          <p class="mt-3">* Die Match-Abos sind später <u>optional</u> buchbar.</p>
          <h2 class="middle_header">
            Du möchtest mehr über die exklusiven Vorteile eines Match-Abos erfahren?
            Dann lasst dich ganz einfach von unserem kompetenten Sales-Team anrufen.
          </h2>

          <div class="row">
            <div style="display: inline-block">
              <v-radio-group
                v-model="user_data.contact_needed"
                color="green"
                :column="false"
              >
                <v-radio color="green" label="Ja" value="ja"></v-radio>
                <v-radio color="green" label="Nein" value="nein"></v-radio>
              </v-radio-group>
            </div>
          </div>

          <div v-if="user_data.contact_needed === 'ja'">
            <label>
              Ansprechpartner
              <span>*/**</span>
            </label>
            <v-text-field
              placeholder="Vor- und Nachname"
              color="green"
              v-model="user_data.contact_needed_data.name"
              solo
            />

            <label>
              Telefonnummer
              <span>*/**</span>
            </label>
            <v-text-field
              placeholder="+491234567890"
              color="green"
              v-model="user_data.contact_needed_data.phone"
              solo
            />

            <label>
              Mitteilung
              <span>**</span>
            </label>
            <v-text-field
              placeholder="Nachricht"
              color="green"
              v-model="user_data.contact_needed_data.mitteilung"
              solo
            />

            <p>** Daten werden nicht im Vereinsprofil veröffentlicht.</p>
          </div>

          <v-btn color="white green--text" @click="back" text>Zurück</v-btn>
          <v-btn
            color="green white--text"
            :loading="loading"
            @click="updateData()"
            :disabled="!isContactNeededFilled"
            >LET'S GO!</v-btn
          >
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>

    <CroppieDialog
      ref="croppieDialog"
      :image="imageSrc"
      :show.sync="showCroppie"
      @upload="cropRegistrationAvatar"
    />
  </div>
</template>

<script>
import moment from 'moment';
import { db } from '@/db';
import croppieMixin from '../../mixins/croppie';
import pushMixin from '../../mixins/push-notifications';
import registerMixin from '../../mixins/register';
import commonMixin from '../../mixins/common';
import CroppieDialog from '../../components/dialogs/CroppieDialog';
import Axios from 'axios';
import { cloudFunctions } from '../../config';

export default {
  name: 'register-scout',

  data: () => ({
    loading: false,
    sex: ['Männlich', 'Weiblich'],
    menu: false,
    since_menu: false,
    selectedStep: 1,
    email: '',
    name: '',
    showPW: false,
    password: '',
    checkbox_anb: false,
    checkbox_datenschutz: false,
    discount: false,
    skipNextWatch: false,
    search: [
      {
        ageRange: [17, 25],
      },
    ],
    rules: {
      required: (value) => !!value || '*Pflichtfeld.',
      min: (v) => v.length >= 8 || '*min. 8 Zeichen',
    },
  }),

  components: {
    CroppieDialog,
  },

  mixins: [croppieMixin, pushMixin, registerMixin, commonMixin],

  watch: {
    'user_data.scoutarea': {
      handler(newVal, oldVal) {
        if (
          newVal.includes('Bundesweit') &&
          (!oldVal || !oldVal.includes('Bundesweit'))
        ) {
          this.user_data.scoutarea = this.$store.state.scoutarea.slice();
        }

        if (oldVal && oldVal.includes('Bundesweit') && !newVal.includes('Bundesweit')) {
          if (!this.skipNextWatch) {
            this.user_data.scoutarea = [];
          } else {
            this.skipNextWatch = !this.skipNextWatch;
          }
        } else if (
          oldVal &&
          oldVal.includes('Bundesweit') &&
          newVal.includes('Bundesweit') &&
          this.$store.state.scoutarea.length !== newVal.length
        ) {
          // removing BW will trigger watcher, to skip next update to empty array use flag to skip it
          this.user_data.scoutarea = this.user_data.scoutarea.filter(
            (e) => e !== 'Bundesweit',
          );
          this.skipNextWatch = true;
        }
      },
    },
  },

  beforeMount() {
    this.$gtm.push({
      event: 'registration_start',
      registration_progress: 'start',
      registration_category: 'fullyRegisterScout',
    });
    if (localStorage.discount) {
      this.discount = true;
    }
  },

  mounted() {
    window.addEventListener('beforeunload', (e) => {
      // Cancel the event
      e.preventDefault();
      // Chrome requires returnValue to be set
      e.returnValue = '';
    });

    this.user_data.place_of_living = 'Deutschland';
    this.$set(this.user_data, 'contact_needed', 'ja');
  },

  computed: {
    formatSinceDate() {
      return this.user_data.working_since
        ? moment(this.user_data.working_since).format('MM/YYYY')
        : '';
    },

    isContactNeededFilled() {
      return this.user_data.contact_needed === 'nein'
        ? true
        : this.user_data.contact_needed_data.name &&
            this.user_data.contact_needed_data.phone;
    },
  },

  methods: {
    back() {
      this.selectedStep--;
      this.$gtm.push({
        event: 'registration',
        registration_progress: `step ${this.selectedStep}`,
        registration_category: 'fullyRegisterScout',
      });
      window.scrollTo(0, 0);
    },

    next() {
      this.selectedStep++;
      this.$gtm.push({
        event: 'registration',
        registration_progress: `step ${this.selectedStep}`,
        registration_category: 'fullyRegisterScout',
      });
      window.scrollTo(0, 0);
    },

    updateData() {
      this.clearLinks();

      this.loading = true;

      const nationality = this.$store.state.nationalities.find(
        (n) => n.item_text === this.user_data.place_of_living,
      );
      this.user_data.search_nationality = nationality.id;
      this.user_data.fullyFilled = true;

      db.collection('scouts')
        .doc(this.user_data.id)
        .update({ ...this.user_data })
        .then(() => {
          this.$gtm.push({
            event: 'registration',
            registration_progress: 'success',
            registration_category: 'fullyRegisterScout',
          });
          this.$router.push({ name: 'scout_home' });
        })
        .then(async () => {
          if (this.user_data.contact_needed === 'ja') {
            const data = {
              contactPerson: this.user_data.contact_needed_data.name,
              phone: this.user_data.contact_needed_data.phone,
              message: this.user_data.contact_needed_data.mitteilung,
              name: this.user_data.name,
              type: this.user_data.userType,
            };

            console.log('data to email', data);

            await Axios({
              method: 'post',
              url: `${cloudFunctions}/sendContactNeedEmail`,
              headers: {
                'content-type': 'application/json',
                'Access-Control-Allow-Origin': '*',
              },
              data,
            });
          }
        });
    },
  },
};
</script>

<style lang="scss">
@import '@/styles/register.scss';
</style>
